import { render, staticRenderFns } from "./tarifarioFamiliaForm.vue?vue&type=template&id=dfa5396e&scoped=true"
import script from "./tarifarioFamiliaForm.vue?vue&type=script&lang=js"
export * from "./tarifarioFamiliaForm.vue?vue&type=script&lang=js"
import style0 from "./tarifarioFamiliaForm.vue?vue&type=style&index=0&id=dfa5396e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa5396e",
  null
  
)

export default component.exports